export enum StatusEffect {
  Bleed = 'bleed',
  Strength = 'strength',
  Weakness = 'weakness',
  Dodge = 'dodge',
  Stealth = 'stealth',
  Blind = 'blind',
  Stunned = 'stunned',
  Regen = 'regeneration',
  Block = 'block',
  Ward = 'ward',
  Barrier = 'barrier',
  Accuracy = 'accuracy',
  Vulnerable = 'vulnerable',
  Armoured = 'armoured',
  Impervious = 'impervious',
  Cursed = 'cursed',
  Poison = 'poisoned',
  Spark = 'spark',
  Burning = 'burning',
  Freezing = 'freezing',
  Shocked = 'shocked',
  Powerful = 'powerful',
  Witty = 'witty',
  Dopey = 'dopey',
  TwinSpell = 'twinspell',
  Snared = 'snared',
  Infusion = 'infusion',
  Wound = 'wound',
  Rested = 'rested',
  Ammo = 'ammo',
  Reactive = 'reactive',
  Clumsy = 'clumsy',
  Brittle = 'brittle',
  Imbue = 'imbue',
  Focus = 'focus',
  Haste = 'haste',
  Slow = 'slow',
  Rebirth = 'rebirth',
  Stance = 'stance',
  Spikes = 'spikes',
  Song = 'song',
  Distracted = 'distracted',
  Delay = 'delay',
  Grappled = 'grappled',
  Ethereal = 'ethereal',
  Petrified = 'petrified',
}
